import React from 'react';
import { useMediaQuery } from 'react-responsive';
import SupportContent from './SupportContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = props => (
  <Desktop>
    <SupportContent {...props} />
  </Desktop>
);

export default DesktopResponsive;
